import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { LinearProgress } from '@mui/material'

import { queries } from '../graphql'
import { Charity } from './charity'
import { LandingPage } from './landing-page'

export function CharityLanding() {
  const { charityId } = useParams()

  const { data: descriptionData, loading: descriptionLoading } = useQuery(queries.charities.getMyCharityDescription, {
    variables: { id: charityId },
  })

  const description = descriptionData?.getMyCharityDescription

  if (descriptionLoading) {
    return (
      <div>
        <LinearProgress />
      </div>
    )
  }

  if (!description) {
    return <Charity />
  }

  return <LandingPage />
}
